import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { Avatar, HorizontalStack, Icon } from '@ztechapps/webui.util'
import { AppVersion } from '@ztechapps/webui.page'
import { ClearAllLocalSettings } from './ClearAllLocalSettings'
import { ToggleColorModeDropdownItem } from './ToggleColorModeDropdownItem'
import { useUser } from '../../../hooks/useUser'

export default function Profile() {
  const { user, logout } = useUser()
  const picture = user?.profile?.picture
  const name = user?.profile?.name ?? ''
  const email = user?.profile?.email ?? ''

  return (
    <Dropdown className="nav-item" align="end">
      <Dropdown.Toggle style={{ cursor: 'pointer' }} as="div">
        <Avatar src={picture} name={name} />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Header>
          <div className="fw-bold">{name}</div>
          <div>{email}</div>
          <AppVersion />
        </Dropdown.Header>

        <Dropdown.Divider />
        <ToggleColorModeDropdownItem />

        <ClearAllLocalSettings />
        <Dropdown.Divider />
        <Dropdown.Item onClick={() => logout()}>
          <HorizontalStack gap={1}>
            <Icon name="sign-out" /> <span>Logout</span>
          </HorizontalStack>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}
